import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import I18n from 'I18n';
import { EVENT_BASED_FIELD_KEYS } from 'customer-data-filters-ui/strategy/eventBasedFilters';
export const makeEventStatusField = (filterFamily, displayType, type) => {
  return DSFieldRecord({
    displayType,
    label: I18n.text(`newCustomerDataFilters.specialFields.${filterFamily}.${EVENT_BASED_FIELD_KEYS.EVENT_STATUS}`),
    name: EVENT_BASED_FIELD_KEYS.EVENT_STATUS,
    type: type || filterFamily,
    displayOrder: 0
  });
};